import React from 'react';
import {Header, Icon, Modal, Select} from 'semantic-ui-react';
import XLSX from 'xlsx';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';

const headerNames = [
  'nd1',
  'nd2',
  'nd3',
  'originalOrderNumber',
  'model',
  'sfx',
  'color',
  'port',
  'total',
  'goshi',
  'fl',
  'tdedp',
  'tde',
  'cl',
  'ch',
  'cb',
  'tcomercial',
  'it',
  'ty',
];

const ConfirmationModal = ({
  showConfirmation,
  setShowConfirmation,
  options,
  acceptedFile,
  uploadRawOrderFile,
  fetchValidateXLXSOrderFile,
}) => {
  const optionsList = options.map((option, index) => ({
    'key': index,
    'value': index,
    'text': option,
  }));


  const mapperRawToRequest = (rawData) => {
    const request = [];
    console.log('rawData', rawData);
    rawData.forEach((rawOrder) => {
      if (String(rawOrder.originalOrderNumber || '').trimEnd().trimStart() === 'Order No.' ||
      String(rawOrder.originalOrderNumber || '').trimEnd().trimStart() === '' ||
      String(rawOrder.port || '').trimEnd().trimStart() === 'Allocation') {
        // pass
      } else {
        console.log('rawOrder', rawOrder);
        const order = {
          'originalOrderNumber': String(rawOrder.originalOrderNumber || '').trimEnd().trimStart(),
          'orderNumber': String(rawOrder.orderNumber || '').trimEnd().trimStart(),
          'model': String(rawOrder.model || '').trimEnd().trimStart(),
          'sfx': String(rawOrder.sfx || '').trimEnd().trimStart(),
          'color': String(rawOrder.color || '').trimEnd().trimStart(),
          'port': String(rawOrder.port || '').trimEnd().trimStart(),
          'total': String(rawOrder.total || '0').trimEnd().trimStart(),
          'fl': String(rawOrder.fl || '0').trimEnd().trimStart(),
          'tdedp': String(rawOrder.tdedp || '0').trimEnd().trimStart(),
          'tde': String(rawOrder.tde || '0').trimEnd().trimStart(),
          'cl': String(rawOrder.cl || '0').trimEnd().trimStart(),
          'ch': String(rawOrder.ch || '0').trimEnd().trimStart(),
          'cb': String(rawOrder.cb || '0').trimEnd().trimStart(),
          'tcomercial': String(rawOrder.tcomercial || '0').trimEnd().trimStart(),
          'it': String(rawOrder.it || '0').trimEnd().trimStart(),
          'ty': String(rawOrder.ty || '0').trimEnd().trimStart(),
          'goshi': String(rawOrder.goshi || '0').trimEnd().trimStart(),
        };
        request.push(order);
      }
    });
    return request;
  };

  const handleDropFile = (acceptedFile, index) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {'type': 'binary'});
      const wsname = wb.SheetNames[index];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, {'header': headerNames, 'range': 3});
      const requestObject = mapperRawToRequest(data);
      uploadRawOrderFile([...requestObject]);
      fetchValidateXLXSOrderFile({'totalOrderArray': [...requestObject]});
    };
    reader.readAsBinaryString(acceptedFile[0]);
    setShowConfirmation(false);
  };

  return (
    <Modal
      basic
      onClose={() => setShowConfirmation(false)}
      onOpen={() => setShowConfirmation(true)}
      open={showConfirmation}
      size='small'
    >
      <Header icon>
        <Icon name='file alternate outline' />
        Escoja la hoja de excel donde consta el pedido
      </Header>
      <Modal.Content>
        <Select fluid
          selection
          placeholder='Seleccionar'
          options={optionsList}
          onChange={(e, {value}) =>
            handleDropFile(acceptedFile, value)
          }
        />
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    'ordersRawData': state.manageOrders.ordersRawData,
  };
};

const {fetchValidateXLXSOrderFile, uploadRawOrderFile} = Actions;

export default connect(mapStateToProps, {
  fetchValidateXLXSOrderFile,
  uploadRawOrderFile,
})(ConfirmationModal);
